import { define } from 'wicked-elements'

define('[data-component="search-input"]', {
  init() {
    this.updatePlaceholder()
    this.autofocus()
  },
  updatePlaceholder () {
    if (window.innerWidth < 768) {
      this.element.setAttribute('placeholder', 'Search…');
    }
  },
  autofocus () {
    const shouldAutofocus = this.element.hasAttribute('data-autofocus')
    if (shouldAutofocus && window.matchMedia("(hover: hover)")?.matches) {
      this.element.focus()
    }
  }
})